import React, {useEffect, useState} from 'react';
import useKnowledgeTest, {KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import {Breadcrumb, Button, Card, Checkbox, Divider, Skeleton} from 'antd';
import Flex from '../../../components/Flex';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import QuickRouter from '../../../utils/QuickRouter';
import Paragraph from 'antd/lib/typography/Paragraph';
import useKnowledgeSubmission from '../../../hooks/apis/useKnowledgeSubmission';
import {useParams} from 'react-router-dom';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';

export default function KnowledgeTestDetailPage() {
  const auth = useAuth();
  const queryByIdState = useKnowledgeTest.queryById();
  const createState = useKnowledgeSubmission.create();
  const params = useParams() as {id?: string};
  const testId = parseInt(params?.id || '');
  const test = queryByIdState.data;
  const [check, setCheck] = useState(false);
  const quickRouter = useQuickRouter();

  function refresh() {
    queryByIdState.request({id: testId}).catch(CommonApiErrorHandler);
  }

  function create() {
    createState
      .request({testId})
      .then(res => {
        return quickRouter.knowledgeSubmissionSubmit(res.id);
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, [auth.currentUser]);

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(test?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card style={{width: 700}}>
          <Skeleton loading={queryByIdState.loading}>
            {test && (
              <Flex direction={'column'} align={'center'}>
                <Title level={4}>{test.contest.name}</Title>
                <Title level={2} style={{marginBottom: 15, marginTop: 0}}>
                  {KnowledgeTestType[test.type]}
                </Title>
                {test.type === KnowledgeTestType.答题演练 && (
                  <Text strong>
                    开放时间: {moment(test.beginTime).format('YYYY-MM-DD HH:mm')} - {moment(test.endTime).format('YYYY-MM-DD HH:mm')}
                  </Text>
                )}
                {test.type === KnowledgeTestType.正式答题 && (
                  <Text strong>
                    {moment(test.beginTime).format('YYYY-MM-DD HH:mm')} 开始，考试时间为 {test.timeLimit} 分钟
                  </Text>
                )}
                <Divider orientation={'left'}>注意事项</Divider>
                <div style={{textAlign: 'left', width: '100%', padding: '0 20px'}}>
                  <Paragraph>
                    单选题共 {test.singleAmount} 题，每题 {test.singleScore} 分；多选题共 {test.multiAmount} 题，每题 {test.multiScore} 分； 总共{' '}
                    {test.singleAmount + test.multiAmount} 题，满分为 {test.singleScore * test.singleAmount + test.multiScore * test.multiAmount} 分。
                  </Paragraph>
                  <Paragraph>考试时间为 {test.timeLimit} 分钟，时间截止后将自动提交试卷，显示得分后再退出程序，否则可能导致交卷失败。</Paragraph>
                  <Paragraph>答题完毕后点击“提交试卷”，显示得分后再退出程序，否则可能导致交卷失败。</Paragraph>
                  <Paragraph>点击“提交试卷”后将无法返回修改。</Paragraph>
                  {test.remark.split('\n').map((remark, i) => (
                    <Paragraph key={i}>{remark}</Paragraph>
                  ))}
                </div>
                <Divider />
                <Checkbox checked={check} onChange={e => setCheck(e.target.checked)} className={'mb-md'}>
                  我已仔细阅读并知晓上述事项
                </Checkbox>
                <Button size={'large'} type={'primary'} disabled={!check} onClick={create}>
                  开始答题
                </Button>
              </Flex>
            )}
          </Skeleton>
        </Card>
      </div>
    </Flex>
  );
}
